/**
 * Asset API
 * Read-only asset ledger (synced from Feishu) endpoints.
 */

import apiClient from './client';
import type { AssetItem, AssetOverview, AssetSyncStatus } from '@/types/assets';

export const assetsApi = {
  getOverview: () =>
    apiClient.get<AssetOverview>('/assets/overview').then((r) => r.data),
  getItems: (assetType?: string) =>
    apiClient
      .get<AssetItem[]>('/assets/items', {
        params: assetType ? { asset_type: assetType } : undefined,
      })
      .then((r) => r.data),
  getSyncStatus: () =>
    apiClient.get<AssetSyncStatus>('/assets/sync-status').then((r) => r.data),
  triggerSync: () =>
    apiClient.post('/assets/sync').then((r) => r.data),
};
